import { TemporaryDrawer as CspTemporaryDrawer, TemporaryDrawerProps } from '@csp/csp-web-ui';
import { FC } from 'react';
import { StaticContentService } from '../service/StaticContentService';

type Props = Omit<TemporaryDrawerProps, 'ariaLabelClose'>;

export const TemporaryDrawer: FC<Props> = ({ ...props }) => {
  const { accessibility } = StaticContentService.getPublicEntry('webHcpUserInterfaceCommon');
  return <CspTemporaryDrawer ariaLabelClose={accessibility.icon.closeDrawer.accessibilityLabel} {...props} />;
};
